export interface ResultadoAjusteExato<T> {
    retorno: T;
    valor: number;
    tentativas: number;
    atingiu: boolean;
}

/** Recalcula somente a previa nativa; a gravacao continua no fluxo de salvar. */
export async function ajustarValorExato<T>(
    alvo: number,
    bruto: number,
    percentualInicial: number,
    calcular: (percentual: number) => Promise<T>,
    lerValor: (retorno: T) => number,
    limiteAlvo = bruto
): Promise<ResultadoAjusteExato<T>> {
    if (![alvo, bruto, percentualInicial, limiteAlvo].every(Number.isFinite) || bruto <= 0 || alvo < 0 || alvo > limiteAlvo) {
        throw new Error('Valor desejado invalido para o calculo do desconto.');
    }
    const centavos = (valor: number) => Math.round(valor * 100);
    const limitar = (valor: number) => Math.min(100, Math.max(0, valor));
    let percentual = limitar(percentualInicial);
    let anterior: {percentual: number; valor: number} | undefined;
    let melhor: ResultadoAjusteExato<T> | undefined;
    for (let tentativa = 1; tentativa <= 3; tentativa++) {
        const retorno = await calcular(percentual);
        const valor = lerValor(retorno);
        if (!Number.isFinite(valor)) throw new Error('O Sankhya retornou um total invalido.');
        const erro = centavos(valor) - centavos(alvo);
        if (!melhor || Math.abs(erro) < Math.abs(centavos(melhor.valor) - centavos(alvo))) {
            melhor = {retorno, valor, tentativas: tentativa, atingiu: erro === 0};
        }
        if (erro === 0) return {...melhor, tentativas: tentativa};
        // Usa a resposta anterior para estimar a variacao real, inclusive arredondamentos.
        const inclinacao = anterior && percentual !== anterior.percentual
            ? (valor - anterior.valor) / (percentual - anterior.percentual) : 0;
        const passo = inclinacao < 0 ? -(valor - alvo) / inclinacao : (valor - alvo) * 100 / bruto;
        anterior = {percentual, valor};
        percentual = limitar(percentual + passo);
    }
    return {...melhor!, tentativas: 3};
}
